export default __webpack_public_path__ + "static/media/img-form.a055e1ec.jpg";